document.addEventListener('DOMContentLoaded', () => {

  const button = document.getElementById('request-quote-btn');
  const modal = document.getElementById('made-to-order-modal');
  const closeButton = document.getElementById('close-made-to-order-modal');

  if (!button || !modal) return;

  const productInput = document.getElementById('quote-product');
  const optionsContainer = document.getElementById('quote-options');
  const urlInput = document.getElementById('quote-url');

  // Open modal
  button.addEventListener('click', (e) => {

    e.preventDefault();

    // Product title
    productInput.textContent = button.dataset.product;

    // Product URL
    urlInput.value = window.location.href;

    // Remove previous generated fields
    optionsContainer.innerHTML = '';

    // Get all option dropdowns
    document.querySelectorAll('select[name^="options["]').forEach(select => {

      const optionName = select.name
        .replace('options[', '')
        .replace(']', '');

    const row = document.createElement('div');

        row.className = 'summary-row';

        row.innerHTML = `
            <span>${optionName}</span>
            <strong>${select.value}</strong>
        `;

        optionsContainer.appendChild(row);

    });

    modal.showModal();

  });

  // Close modal
  closeButton.addEventListener('click', () => {
    modal.close();
  });

  // Close when clicking outside
  modal.addEventListener('click', (e) => {

    const rect = modal.getBoundingClientRect();

    const inside =
      rect.top <= e.clientY &&
      e.clientY <= rect.top + rect.height &&
      rect.left <= e.clientX &&
      e.clientX <= rect.left + rect.width;

    if (!inside) {
      modal.close();
    }

  });

  // Format the email before submit
  const form = modal.querySelector('form');

  if (form) {

    form.addEventListener('submit', () => {

      const firstName = document.getElementById('quote-first-name').value;
      const lastName = document.getElementById('quote-last-name').value;
      const email = document.getElementById('quote-email').value;
      const phone = document.getElementById('quote-phone').value;

      let message = '';

      message += '==============================\n';
      message += 'NEW MADE TO ORDER INQUIRY\n';
      message += '==============================\n\n';

      message += 'CUSTOMER\n';
      message += '------------------------------\n';
      message += `Name: ${firstName} ${lastName}\n`;
      message += `Email: ${email}\n`;
      message += `Phone: ${phone}\n\n`;

      message += 'REQUESTED ITEM\n';
      message += '------------------------------\n';
      message += `${productInput.value}\n\n`;

      message += 'SPECIFICATIONS\n';
      message += '------------------------------\n';

      document.querySelectorAll('#quote-options input').forEach(input => {

        const label = input.name
          .replace('contact[', '')
          .replace(']', '');

        message += `${label}: ${input.value}\n`;

      });

      message += '\nPRODUCT URL\n';
      message += '------------------------------\n';
      message += window.location.href;

      document.getElementById('quote-message').value = message;

    });

  }

});